"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var ModalMessage = function ModalMessage(props) {
  var message = props.message,
    icon = props.icon,
    description = props.description;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('modal__msg');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-hd")
  }, icon && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-icon")
  }, icon), message && /*#__PURE__*/_react.default.createElement("h3", {
    className: "".concat(prefixCls, "-title")
  }, message)), description && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-bd")
  }, description));
};
var _default = exports.default = ModalMessage;